/*
 * Docs:
 * https://marmelab.com/react-admin/Theming.html#writing-a-custom-theme
 */
import { createTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';

export const CoiTheme = createTheme({
  palette: {
    primary: {
      main: '#0D4464',
    },
    secondary: {
      main: '#FF9200',
      contrastText: '#fff',
    },
    error: red,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
  overrides: {
    MuiButton: {
      root: {
        textDecoration: 'none',
        boxShadow: 'none',
        borderRadius: '2px',
      },
      contained: {
        boxShadow: 'none',
      },
    },
    MuiTypography: {
      h6: {
        fontSize: '24px',
      },
      subtitle1: {
        fontSize: '14px',
        color: 'rgba(33,35,34,0.5)',
        lineHeight: '16px',
        fontWeight: '500',
        textTransform: 'uppercase',
      },
      subtitle2: {
        fontSize: '16px',
        fontWeight: '500',
      },
      body2: {
        fontSize: '13px',
        color: 'rgba(33,35,34,0.5)',
        lineHeight: '15px',
      },
      body1: {
        fontSize: '12px',
        fontWeight: '500',
        color: '#212322',
        lineHeight: '14px',
      },
      h5: {
        fontSize: '1.5rem',
      },
    },
    MuiToolbar: {
      root: {
        '& li[role=menuitem]': {
          color: '#fff',
        },
      },
    },
    MuiTable: {
      root: {
        backgroundColor: 'white',
      },
    },
    MuiStepIcon: {
      active: {
        color: '#00A1A1 !important',
      },
      completed: {
        color: '#00A1A1 !important',
      },
    },
    MuiStepLabel: {
      root: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
      },
      labelContainer: {
        display: 'flex',
        height: '50px',
        flex: '1',
        alignItems: 'center',
        margin: '0 12px 0 13px',
        boxShadow: '0 0 7px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)',
        backgroundColor: '#fff',
      },
      active: {
        backgroundColor: '#fff !important',
        height: '50px',
        width: '100%',
        lineHeight: '50px',
        paddingLeft: '20px',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
        boxShadow: '0 0 7px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24) !important',
      },
      '&$disabled': {
        border: 'none',
        '& span': {
          border: 'none',
          boxShadow: 'none',
          backgroundColor: 'transparent',
        },
      },
      completed: {
        paddingLeft: '20px',
      },
    },
    MuiStep: {
      root: {
        '& span': {
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      },
    },
    MuiStepContent: {
      root: {
        marginTop: '0px',
        paddingRight: '0px',
      },
    },
    MuiCollapse: {
      entered: {
        height: 'auto',
        overflow: 'visible',
      },
    },
    RaAutocompleteSuggestionList: {
      suggestionsPaper: { maxHeight: '40vh' },
    },
    MuiPaper: {
      elevation2: {
        '& ul[role=listbox]': {
          maxHeight: '250px',
          overflowY: 'auto',
        },
      },
    },
  },
});
